/* eslint-disable no-unreachable */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import queryString from 'querystring';
import { GetTitle } from './boardTitle';
import { getBreadScrumb } from './breadscrumb';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function BoardWriter(routeProps: RouteComponentProps) {
  // 게시글 정보
  const [boardItems, setBoardItems] = useState<any>();
  // 업로드된 파일
  const [attachedFiles, setAttachedFiles] = useState<any[]>([]);
  // 업로드예정 파일
  const [attachingFiles, setAttachingFiles] = useState<File[]>([]);
  // 삭제예정 파일
  const [removingFiles, setRemovingFiles] = useState<any[]>([]);
  const [titleText, setTitleText] = useState('');
  const [userText, setUserText] = useState(window.localStorage.getItem('name') || '');
  const [passWordText, setPassWordText] = useState('');
  const [emailText, setEmailText] = useState('');
  const [contextText, setContextText] = useState('');
  const dispatch = useDispatch();
  const option: any = queryString.decode(routeProps.location.search.substring(1));
  const reply = option.reply?.toString();

  useEffect(() => {
    if (window.localStorage.getItem('token') === null && option.ctgy === 'qna') {
      dispatch(toast.error({ message: '로그인이 필요합니다.' }));
      routeProps.history.push('/login');
    } else if (option.update !== undefined) {
      getBoardItem();
    }
  }, []);

  const getBoardItem = async () => {
    await server
      .getBoardItem(option.ctgy, option.id)
      .then((payload) => {
        setBoardItems(payload);
        const boardItem: any = routeProps.location.state;
        setTitleText(boardItem.subject);
        setContextText(boardItem.content);
        let attacheFiles: any = [];
        for (let i = 1; i <= 5; i++) {
          if (payload[`attach${i}`]) {
            const attacheFile: any = {};
            attacheFile.tag = `attach${i}`;
            attacheFile.filename = payload[`attach${i}`];
            attacheFile.url = payload[`attach${i}Url`];
            attacheFiles = [...attacheFiles, attacheFile];
          }
        }
        setAttachedFiles(attacheFiles);
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  const deleteImg = (id: any) => {
    const imgId = attachingFiles?.filter((file) => file.lastModified !== id);
    setAttachingFiles(imgId);
  };

  const attachFileDom = () => {
    if (reply === undefined) {
      return (
        <li>
          <span>첨부파일</span>
          <div className="input-file-container">
            <input
              className="input-files"
              id="file01"
              type="file"
              multiple
              onChange={(e) => {
                if (e.target !== null && e.target.files !== null) {
                  if (
                    e.target.files.length > 5 ||
                    attachedFiles.length + e.target.files.length > 5
                  ) {
                    dispatch(toast.error({ message: '파일은 5개까지만 선택이 가능합니다.' }));
                    return;
                  }
                  setAttachingFiles(Array.from(e.target.files));
                }
              }}
            />
          </div>
          {/* 서버에 저장된 파일가져오는 로직 */}
          {attachedFiles.map((attachedFile) => (
            <ul className="files" key={Math.random()}>
              <li key={attachedFile.tag}>
                {/* <button
                  className="btn-attach-file"
                  type="button"
                  onClick={() => {
                    window.location.href = `${process.env.REACT_APP_API_URL}/public${attachedFile.url}`;
                  }}
                >
                  {attachedFile.filename}
                </button> */}
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <a
                  href={`${process.env.REACT_APP_API_URL}/public${attachedFile.url}`}
                  className="btn-file"
                  target="_blank"
                >
                  {attachedFile.filename}
                </a>
                <button
                  type="button"
                  className="btn-delete-attach-file"
                  onClick={() => {
                    setAttachedFiles(attachedFiles.filter((file) => file.tag !== attachedFile.tag));
                    setRemovingFiles([...removingFiles, attachedFile]);
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 0 24 24"
                    width="24"
                  >
                    <path d="M0 0h24v24H0z" fill="none" />
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </button>
              </li>
            </ul>
          ))}
          {attachingFiles &&
            attachingFiles.map((file) => (
              <div key={file.lastModified}>
                {file.name}
                <button type="button" onClick={() => deleteImg(file.lastModified)}>
                  x
                </button>
              </div>
            ))}
        </li>
      );
    }
    return <></>;
  };

  const onClickValidation = () => {
    if (titleText.length <= 0) {
      dispatch(toast.error({ message: '제목을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (contextText.length <= 0) {
      dispatch(toast.error({ message: '내용을 입력해주세요.', title: '필수 입력 항목 누락' }));
      return;
    }
    if (attachedFiles.length + attachingFiles.length - removingFiles.length > 5) {
      dispatch(toast.error({ message: '파일은 5개 까지만 등록이 가능합니다.' }));
      return;
    }
    onClickSave();
  };

  const onClickSave = async () => {
    if (option.update !== undefined && option.update) {
      // 글 수정 할 때
      await server
        .updateBoard(option.ctgy.toString(), option.id.toString(), {
          subject: titleText,
          content: contextText,
          link: '',
        })
        .then((payload) => {
          routeProps.history.push(`/board/${option.ctgy.toString()}`);
          return payload;
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });

      if (removingFiles.length > 0) {
        const removeFiles = removingFiles.map((file) => file.tag);
        await server
          .deleteAttaches(option.ctgy.toString(), option.id.toString(), removeFiles)
          .then(() => {
            routeProps.history.push(`/board/${option.ctgy.toString()}`);
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      }
      if (attachingFiles.length > 0) {
        const uploadFile: any = {};
        attachingFiles.forEach((file, index) => {
          uploadFile[`attach${attachedFiles.length + 1 + index}`] = file;
        });
        await server
          .uploadAttaches(uploadFile, option.ctgy.toString(), +option.id)
          .then(() => {
            routeProps.history.push(`/board/${option.ctgy.toString()}`);
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      }
    } else {
      // 글 수정이 아닐 시
      const newSaveData = await server
        .writeBoard(option.ctgy.toString(), {
          subject: titleText,
          content: contextText,
          link: '',
          attach1: '',
          attach2: '',
          attach3: '',
          attach4: '',
          attach5: '',
        })
        .then((payload) => {
          routeProps.history.push(`/board/${option.ctgy.toString()}`);
          return payload;
        })
        .catch((error) => {
          dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
          console.log(error);
        });

      if (attachingFiles.length > 0) {
        const newSaveDataId = newSaveData.id;
        const uploadFile: any = {};
        attachingFiles.forEach((file, index) => {
          uploadFile[`attach${attachedFiles.length + 1 + index}`] = file;
        });
        await server
          .uploadAttaches(uploadFile, option.ctgy.toString(), newSaveDataId)
          .then(() => {
            routeProps.history.push(`/board/${option.ctgy.toString()}`);
          })
          .catch((error) => {
            dispatch(
              toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' })
            );
            console.log(error);
          });
      }
    }
  };

  return (
    <div className="content">
      {getBreadScrumb(option.title?.toString())}
      {GetTitle(
        option.ctgy,
        option.title?.toString(),
        option.subTitle?.toString(),
        '',
        '',
        false,
        () => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {},
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (param: string) => {}
      )}
      <ul className="inputs">
        <li>
          <span>제목</span>
          <input
            className="full"
            type="text"
            value={titleText}
            onChange={(dom) => {
              setTitleText(dom.target.value);
            }}
          />
        </li>
        <li>
          <span>작성자</span>
          <input type="text" readOnly value={userText} />
        </li>
        {attachFileDom()}
        <li>
          <textarea
            name=""
            id=""
            rows={20}
            value={contextText}
            onChange={(dom) => {
              setContextText(dom.target.value);
            }}
          />
        </li>
      </ul>
      <div className="buttons">
        <button
          className="btn-sub"
          type="button"
          onClick={() => {
            routeProps.history.goBack();
          }}
        >
          취소
        </button>
        <button
          className="btn-main"
          type="button"
          onClick={() => {
            onClickValidation();
          }}
        >
          등록하기
        </button>
      </div>
    </div>
  );
}
